import { Tree } from "../../../../utils/vue-tree-list";
import { mapGetters } from "vuex";
import { cloneDeep } from "lodash";

export default {
  data: function () {
    return {
      account: null,
      data: new Tree([]),
      /*  evaluatingNode: null,*/
      lastEvaluated: 0,
      evidencesRequested: false,
      evaluationData: null,
    };
  },
  computed: {
    availableLeafs() {
      var array = [];
      this.getRequirementList.forEach(function (leaf) {
        if (
          leaf.evaluation_administrator_node_editRequirement_requireEvidences ===
            true ||
          leaf.evaluation_administrator_node_editRequirement_evidencesReady
        ) {
          array.push(leaf);
        }
      });
      return array;
    },
    isPreviousEnabled() {
      if (this.getRequirementIndex - 1 >= 0) {
        return true;
      } else {
        return false;
      }
    },

    isNextEnabled() {
      if (this.getRequirementIndex + 1 < this.getRequirementList.length) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters([
      "getSelectedEvaluation",
      "getSelectedRequirement",
      "getRequirementIndex",
      "getRequirementList",
    ]),
  },
  watch: {
    getSelectedEvaluation: async function () {
      this.evaluationData = this.getSelectedEvaluation;
      if (
        this.evaluationData &&
        this.evaluationData.evaluation &&
        this.evaluationData.evaluation.children &&
        Array.isArray(this.evaluationData.evaluation.children)
      ) {
        this.data = cloneDeep(this.evaluationData.evaluation);
        this.processData();
      }
    },
  },
  methods: {
    processData() {},
    async getEvaluations() {
      await this.$store.dispatch("getEvaluation", {
        evaluationId: this.evaluationId,
      });
    },
    async moveEvaluatingNode(advance) {
      let requirementId = null;
      if (
        advance &&
        this.getRequirementIndex + 1 < this.getRequirementList.length
      ) {
        requirementId =
          this.getRequirementList[this.getRequirementIndex + 1].id;
      }
      if (!advance && this.getRequirementIndex - 1 >= 0) {
        requirementId =
          this.getRequirementList[this.getRequirementIndex - 1].id;
      }
      await this.$store.dispatch("getEvaluation", {
        evaluationId: this.evaluationId,
        requirementId,
      });
    },
    async clearEvaluatingNode() {
      this.$store.commit("CLEAR_SELECTED_REQUIREMENT");
    },
    getNewTree() {
      var vm = this;

      function _dfs(oldNode) {
        var newNode = {};

        for (var k in oldNode) {
          if (k !== "children" && k !== "parent") {
            newNode[k] = oldNode[k];
          }
        }

        if (oldNode.children && oldNode.children.length > 0) {
          newNode.children = [];
          for (var i = 0, len = oldNode.children.length; i < len; i++) {
            newNode.children.push(_dfs(oldNode.children[i]));
          }
        }
        return newNode;
      }

      vm.newTree = _dfs(vm.data);
      return vm.newTree;
    },
  },
};
